<template>
  <Select
    v-model="internalValue"
    :options="timezonesItems"
    :disabled='disabled'
    :placeholder="placeholder || $t('test.timezone.placeholder')"
    :title="title || this.$t('timezone')"
    size="xsmall"
    class="timezone-picker"
  />
</template>

<script>
import { getGroupedTimezonesList } from '@/utils/dateUtils';

import Select from '@/components/common/Select.vue';

export default {
  name: 'TimezonePicker',
  components: {
    Select,
  },
  props: {
    disabled: {
      required: false,
      default: false,
      type: Boolean,
    },
    value: {
      type: String,
    },
    title: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  computed: {
    timezonesItems() {
      return getGroupedTimezonesList().map(tz => ({
        value: tz.offset,
        title: `(GMT${tz.formattedOffset}) ${tz.name}`,
      }));
    },
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        if (!this.disabled) {
          this.$emit('input', value);
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.timezone-picker {
  ::v-deep span {
    text-transform: uppercase;
  }

  ::v-deep .el-input__inner {
    height: 28px;
  }
}

</style>
